import { useEffect, useState } from "react";
import { useAuth } from "hooks/useAuth";
import { db } from "services/firebase";

/**
 * Resolves whether the caller holds an active Global TCI Manager platform assignment.
 */
export function useGlobalTciManager() {
  const { user, tokenClaims } = useAuth();
  const claimGtm = Boolean(tokenClaims?.globalTciManager);
  const [isGlobalTciManager, setIsGlobalTciManager] = useState(claimGtm);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    if (!user?.uid) {
      setIsGlobalTciManager(false);
      setLoading(false);
      return undefined;
    }

    if (claimGtm) {
      setIsGlobalTciManager(true);
      setLoading(false);
      return undefined;
    }

    setLoading(true);
    const assignmentId = `${user.uid}__global-tci-manager__platform__none`;
    db.collection("fdeAssignments")
      .doc(assignmentId)
      .get()
      .then((snap) => {
        if (cancelled) return;
        const data = snap.data() || {};
        const hasAssignment =
          snap.exists && data.role === "global-tci-manager" && data.status === "active";
        setIsGlobalTciManager(hasAssignment || claimGtm);
      })
      .catch((err) => {
        console.error("[useGlobalTciManager] load failed", err);
        if (!cancelled) setIsGlobalTciManager(claimGtm);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [user?.uid, claimGtm]);

  return { isGlobalTciManager, loading };
}
